<template>
  <!-- v-if="section.seatLayout" -->
  <!-- Add comment -->
  <div
    :class="fullscreen && posFnb ? '' : 'pos-seatlayout-wrapper-fullscreen'"
    ref="posWrapper"
    class="width:100%"
  >
    <div class="" v-if="sectionType == 1">
      <BrandSection :organizationDetails="orgDetails || organizationDetails" />
    </div>
    <div
      class=""
      v-else-if="sectionType == 2 && !isEpix && paginatedMovies.length"
    >
      <div v-if="ShowArrayList.length">
        <template v-if="false">
          <div class="dual-display">
            <!-- Movies grid -->
            <div class="movies">
              <div
                class="movie-card"
                v-for="(movie, movieIndex) in paginatedMovies"
                :key="movie[0].movie_title + '_' + movieIndex"
              >
                <!-- Poster -->
                <div class="poster">
                  <img
                    v-lazy="
                      getLangSpecificAttribute(
                        movie[0].altMovieContent,
                        movie[0].lang_id,
                        'artwork'
                      )
                    "
                    :alt="`NO IMG`"
                  />
                </div>

                <!-- Info -->
                <div class="info">
                  <h3 class="title">{{ movie[0].movie_title }}</h3>
                  <p class="meta">
                    {{ movie[0].lang_version || movie[0].language_name }} •
                    {{ movie[0].mrrdr_runtime }} Min •
                    {{ movie[0].rating }}
                  </p>

                  <!-- Showtimes -->
                  <div class="showtimes">
                    <span
                      v-for="(singleShow, showIndex) in getSortArrayHere(movie)"
                      :key="singleShow.ss_id + '_' + showIndex"
                      class="showtime"
                    >
                      {{
                        moment(singleShow.ss_start_show_time, "HH:mm").format(
                          TIME_FORMAT
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template>
          <div
            class="dual-display"
            :class="{ 'dual-display-client': isSpecificClient }"
          >
            <!-- Movies grid -->
            <div class="movies">
              <div
                class="movie-card"
                v-for="(movie, movieIndex) in paginatedMovies"
                :key="movie[0].movie_title + '_' + movieIndex"
              >
                <!-- Poster -->
                <div class="poster">
                  <img
                    v-lazy="
                      getLangSpecificAttribute(
                        movie[0].altMovieContent,
                        movie[0].lang_id,
                        'artwork'
                      )
                    "
                    alt="NO IMG"
                  />
                </div>

                <!-- Info -->
                <div class="info">
                  <h3 class="title">{{ movie[0].movie_title }}</h3>

                  <p class="meta">
                    {{ movie[0].lang_version || movie[0].language_name }} •
                    {{ movie[0].mrrdr_runtime }} Min •
                    {{ movie[0].rating }}
                  </p>

                  <div class="showtimes">
                    <span
                      v-for="(singleShow, showIndex) in getSortArrayHere(movie)"
                      :key="singleShow.ss_id + '_' + showIndex"
                      class="showtime"
                    >
                      {{
                        moment(singleShow.ss_start_show_time, "HH:mm").format(
                          TIME_FORMAT
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <b-modal
              ref="listed-movie-synopsis"
              id="listed-movie-synopsis"
              size="lg"
              centered
              modal-lg
              hide-header
              hide-footer
            >
              <div class="row" v-if="movieDetails">
                <div class="col-md-5">
                  <img
                    v-lazy="
                      getLangSpecificAttribute(
                        movieDetails.MovieContent,
                        AREA_LANG_ID,
                        'artwork_image'
                      )
                    "
                    class="img-fluid w-100 rounded-10"
                  />
                </div>
                <div class="col-md-7">
                  <div class="row mr-0">
                    <div class="col-12 border-bottom">
                      <div class="row">
                        <div class="col-md-10 d-flex align-items-center">
                          <h5 class="font-weight-bold mb-0">
                            {{
                              getLangSpecificAttribute(
                                movieDetails.MovieContent,
                                AREA_LANG_ID,
                                "mc_title"
                              ) || movieDetails.mc_title
                            }}
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <button
                            class="btn-modal-close pos-modal-close"
                            v-on:click="onCloseModal('movieSynopsis')"
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("release") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.mrrdr_release_date | dateparse }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("language", 1) }}
                        </div>
                        <div class="col-8">{{ movieDetails.lang_name }}</div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("rating") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.rating }}&nbsp;&nbsp;
                          <span v-if="movieDetails.earliest_bday" class=""
                            >({{ $t("earliest_bday") }}:
                            {{ movieDetails.earliest_bday }})</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("format", 1) }}
                        </div>
                        <div class="col-8">
                          <span>{{ movieDetails.mf_name }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("soundformat") }}
                        </div>
                        <div class="col-8">
                          <span>{{ movieDetails.sound_format_name }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("running") }} {{ $t("time") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.mrrdr_runtime }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("genre", 1) }}
                        </div>
                        <div class="col-8">
                          <!-- movieDetails.g_name.toString() -->
                          {{
                            movieDetails.g_name &&
                              movieDetails.g_name.join(", ")
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("castCrew") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.movie_cast_crew }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-12 py-2 border-bottom"
                      v-if="
                        movieDetails.movie_production &&
                          movieDetails.movie_production.length > 0
                      "
                    >
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("production") }}
                        </div>
                        <div class="col-8">
                          {{
                            movieDetails.movie_production &&
                            movieDetails.movie_production.length > 0
                              ? movieDetails.movie_production
                                  .map((x) => x.production_name)
                                  .toString()
                              : ""
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("synopsis") }}
                        </div>
                        <div class="col-8" :dir="isSynopsisRtl ? 'rtl' : 'ltr'">
                          {{
                            getLangSpecificAttribute(
                              movieDetails.MovieContent,
                              AREA_LANG_ID,
                              "mc_plot"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </template>
      </div>
    </div>
    <div class="" v-else-if="sectionType == 3 && seatTypeLocal.length">
      <div
        class="relative text-center"
        style="width: 50%; margin: auto; height: 35px"
      >
        <img
          src="@/assets/img/pos/pos-screen.png"
          class="img-fluid w-100 alignment"
          style="height: 35px"
        />
        <span
          class="eyes-text mb-2"
          :class="
            reverse
              ? 'pos-seatlayout-rotate'
              : QfxClient
              ? 'font-weight-bold'
              : ''
          "
          :style="`font-size:${QfxClient ? '22px' : ''}`"
        >
          {{ $t("SCREEN") }}-{{ getScheduleScreenName }}
        </span>
      </div>
      <div
        class="table-responsive pos-seatlayout mt-3"
        :class="[{ 'pos-seatlayout-rotate': reverse, transform06: !isEpix }]"
      >
        <div class="alignment" :style="`zoom:${numzoom}`">
          <table
            class=""
            v-for="(seat, seatIndex) in seatTypeLocal"
            :key="seatIndex"
          >
            <tr v-if="!isWheelChairOnlyRow(seat.seatsFinal)">
              <td colspan="30">
                <!-- seatTypetext -->
                <div class="relative text-uppercase">
                  <span class="seatTypetext">
                    {{ seat.seatType }}
                    ({{ parseFloat(seat.seat_price).toFixed(3) }}
                    {{ currencyD || "" }})
                  </span>
                </div>
              </td>
            </tr>

            <tr
              v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
              :key="seatRowIndex"
            >
              <div style="font-weight: bold">
                <!-- {{ seatRow[0].sl_seat_name.slice(0, 1) }} -->
                <!-- {{ toCheckAlphabets() }} -->
                {{
                  starClient &&
                  !toCheckAlphabets(
                    getSafe(
                      () =>
                        seatRow.filter((r) => !!r.sl_seat_name)[0].sl_seat_name
                    )
                  )
                    ? getSafe(
                        () =>
                          seatRow
                            .filter((r) => !!r.sl_seat_name)[0]
                            .sl_seat_name.slice(0, 2)
                            .replaceAll("-", ""),
                        " "
                      )
                    : getSafe(
                        () =>
                          seatRow.filter((r) => !!r.sl_seat_name)[0]
                            .sl_seat_name[0],
                        " "
                      )
                }}
                <!-- {{
                  getSafe(
                    () =>
                      seatRow.filter((r) => !!r.sl_seat_name)[0].sl_seat_name[0],
                    " "
                  )
                }} -->
              </div>
              <td
                v-for="(singleSeat, singleSeatIndex) in seatRow"
                :key="'index' + singleSeatIndex"
                :class="[
                  {
                    'lounger-container ': singleSeat.srt_seat_capacity > 1,
                  },
                  singleSeat['className'] ? singleSeat['className'] : '',
                ]"
              >
                <!-- {{singleSeat.seat_reserve_type_id}} -->
                <div
                  v-if="singleSeat.covidBlocked || singleSeat.covidBlockedTemp"
                  class="text-center"
                >
                  <CovidBlockedSeatIcon
                    :active="singleSeat.selectStatus == true"
                  />
                </div>
                <div
                  v-else-if="singleSeat.seat_reserve_type_id == 5"
                  class="pos-seat cursor-pointer"
                  :style="{
                    borderColor:
                      singleSeat.selectStatus == true
                        ? '#01d04a !important'
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                    backgroundColor:
                      singleSeat.selectStatus == true
                        ? ''
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                  }"
                  :class="
                    singleSeat.isVipReserved
                      ? `${
                          QfxClient ? 'bg-qfx-unpaid mix-blend-mode' : ''
                        } reserved-seat taken pointer-events`
                      : singleSeat.srt_id == 2
                      ? 'normal-seat pointer-events'
                      : singleSeat.seat_reserve_type_id == 8
                      ? 'pointer-events'
                      : singleSeat.seat_reserve_type_id == 13
                      ? 'pointer-events'
                      : ''
                  "
                >
                  <img
                    :src="getSeatIconURL(singleSeat)"
                    height="28"
                    width="28"
                  />
                </div>
                <div
                  :style="{
                    borderColor:
                      singleSeat.selectStatus == true
                        ? '#01d04a !important'
                        : singleSeat.seat_reserve_type_id == 8
                        ? checkSeatPriortyColor(singleSeat)
                        : singleSeat.seat_reserve_type_id == 4
                        ? 'green'
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                    backgroundColor:
                      singleSeat.selectStatus == true
                        ? '#01d04a !important'
                        : singleSeat.seat_reserve_type_id == 8
                        ? checkSeatPriortyColor(singleSeat)
                        : 'transparent !important',
                    // borderColor:
                    //   singleSeat.selectStatus == true
                    //     ? '#01d04a !important'
                    //     : singleSeat.seat_reserve_type_id == 8
                    //     ? checkSeatPriortyColor(singleSeat)
                    //     : singleSeat.seat_reserve_type_id == 4
                    //     ? 'green'
                    //     : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                    //         .sst_seat_color_code + ' !important',
                    // backgroundColor:
                    //   singleSeat.selectStatus == true
                    //     ? ''
                    //     : singleSeat.seat_reserve_type_id == 8
                    //     ? QfxClient
                    //       ? '#dc3545'
                    //       : checkSeatPriortyColor(singleSeat)
                    //     : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                    //         .sst_seat_color_code + ' !important'
                  }"
                  v-else
                  class="pos-seat cursor-pointer flexSeats"
                  :class="
                    singleSeat.isVipReserved
                      ? `${
                          QfxClient ? 'bg-qfx-unpaid mix-blend-mode' : ''
                        } reserved-seat taken pointer-events`
                      : singleSeat.srt_id == 2
                      ? 'normal-seat pointer-events'
                      : singleSeat.seat_reserve_type_id == 8
                      ? 'pointer-events'
                      : singleSeat.seat_reserve_type_id == 13
                      ? 'pointer-events'
                      : ''
                  "
                >
                  <!-- <img
                    v-if="!checkSeatPriortyColor(singleSeat)"
                    :src="getSeatIconURL(singleSeat)"
                    height="28"
                    width="28"
                    :style="
                      singleSeat.seat_reserve_type_id == 4
                        ? 'background-color:green'
                        : ''
                    "
                  /> -->
                  <img
                    v-if="
                      ['3', '4', '5', '13', '12'].includes(
                        String(singleSeat.seat_reserve_type_id)
                      )
                    "
                    :src="getSeatIconURL(singleSeat)"
                    height="28"
                    width="28"
                    :style="
                      singleSeat.seat_reserve_type_id == 4
                        ? 'background-color:green'
                        : ['3', '5', '13'].includes(
                            String(singleSeat.seat_reserve_type_id)
                          )
                        ? 'background-color:black'
                        : ''
                    "
                  />
                  <span v-else> {{ singleSeat.sl_seat_name }}</span>
                </div>
                <!-- <div
                  v-if="singleSeat.srt_id == 2"
                  class="pos-seatNumber pt-1"
                ></div>
                <div v-else class="pos-seatNumber pt-1">
                  {{ singleSeat.sl_seat_name }}
                </div> -->
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="" v-else-if="sectionType == 4 && fnbItemsList.length">
      <template>
        <div class="display-wrapper">
          <h3 class="title">Food & Beverages</h3>
          <div ref="fnbSection" class="fnbSection">
            <div class="fnb-grid">
              <div
                v-for="(item, itemIndex) in fnbItemsList"
                :key="itemIndex + '_item' + item.item_id"
                class="fnb-card"
              >
                <span v-if="getSelectedCount(item.item_id)" class="badge">{{
                  getSelectedCount(item.item_id)
                }}</span>
                <img :src="item.item_image_url" alt="" />
                <p class="name">{{ item.item_name }}</p>
                <p class="price">
                  {{ currFormat(item.fp_total_amount) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="" v-else-if="sectionType == 5">
      <template>
        <div class="checkout-summary">
          <CheckoutSummary
            :deductionArray="deductionArray"
            :finalAmountToPay="finalAmountToPay"
            :splitPaymentModes="splitPaymentModes"
            :change_amount="String(change_amount || 0)"
            :fnbList="FnBList"
            :currCode="displayCurrCode"
            :charges="AdditionalChargeList"
            :showDataArr="showDataArr"
            :offerData="offerData"
            :addonArray="addonArray"
            :RateCardAddonsChargesFinalAmount="RateCardAddonsChargesFinalAmount"
          />
        </div>
      </template>
    </div>
    <div class="final-ticket-screen" v-else-if="sectionType == 6">
      <FinalTicketV2
        :BookingDetails="finalTicketDetails['bookingDetails']"
        :bookingCode="finalTicketDetails['bookingCode']"
        :yourTicket="finalTicketDetails['yourTicket']"
        :finalAmountPaid="String(finalTicketDetails['finalAmountPaid'])"
        :FnbItems="finalTicketDetails['fnbItems']"
        :curr_code="finalTicketDetails['curr_code'] || displayCurrCode"
        :extraTickets="finalTicketDetails['extraTickets'] || []"
      />
    </div>
    <div class="" v-else-if="sectionType == 7">
      <CCAvenueQR
        v-if="showCCAvenueQR"
        :qrData="ccAvenueQRDetails['qrCode']"
        :amount="currFormat(ccAvenueQRDetails['amount'] || 0)"
        :curr_code="ccAvenueQRDetails['curr_code']"
      />
    </div>
    <div class="qrisQrcode" v-else-if="sectionType == 8">
      <div class="mx-auto col-5">
        <p class="text-center my-4">Pay BY QRIS</p>
        <img
          :src="qrisDetails.qrCode"
          height="250"
          width="250"
          class="mx-auto my-3 d-block mt-2"
        />
        <p class="text-center">
          Please scan the qr to proceed with payment of
          <span class="font-weight-bold"
            >{{ qrisDetails.currCode }}
            {{ currFormat(qrisDetails.amount) }}</span
          >
        </p>
      </div>
    </div>
    <div v-else-if="sectionType == 9">
      <div class="col-12 mt-4">
        <ClubLoyaltySummary :benefits="clubBenefits.data" />
      </div>
    </div>
    <div v-else>
      <BrandSection :organizationDetails="orgDetails || organizationDetails" />
    </div>

    <!-- <div
      class="marketing-container"
      v-if="
        isEpix && !posBooking && !posFnb && !showCheckout && !showCCAvenueQR
      "
    >
      <img
        src="@/assets/img/dual_display_marketing.jpg"
        height="580"
        width="1400"
      />
    </div> -->
    <div v-if="alternateModal.open" class="alternate-overlay">
      <div class="alternate-dialog">
        <div class="alternate-dialog-header">
          {{ alternateModal.title || "Select Alternate Item" }}
        </div>
        <div
          v-if="!alternateModal.items.length"
          class="alternate-empty"
        >
          No alternate items found.
        </div>
        <div v-else class="alternate-items">
          <div
            v-for="(item, itemIndex) in alternateModal.items"
            :key="item.item_id + '_' + itemIndex"
            class="alternate-card"
          >
            <span
              v-if="alternateAddedCount(item.item_id)"
              class="badge"
            >{{ alternateAddedCount(item.item_id) }}</span>
            <img
              :src="item.item_image_url"
              alt=""
            />
            <p class="name">{{ item.item_name || item.recipe_name }}</p>
            <p class="price">{{ currFormat(item.fp_total_amount) }}</p>
          </div>
        </div>
        <div v-if="alternateTotalAdded" class="alternate-dialog-footer">
          <strong>{{ alternateTotalAdded }}</strong> added
        </div>
      </div>
    </div>
    <div
      v-if="comboModal.open"
      class="combo-overlay"
      style="position:fixed;top:0;right:0;bottom:0;left:0;z-index:3000;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;padding:24px;box-sizing:border-box;"
    >
      <div
        class="combo-dialog"
        style="width:92%;max-width:1100px;max-height:86vh;background:#fff;border-radius:8px;box-shadow:0 12px 40px rgba(0,0,0,0.28);display:flex;flex-direction:column;overflow:hidden;"
      >
        <div
          class="combo-dialog-header"
          style="display:flex;align-items:center;padding:14px 20px;font-size:22px;font-weight:600;border-bottom:1px solid #eaeaed;background:#fff;"
        >
          <span>{{ comboModal.title || "Customize combo" }}</span>
          <span
            v-if="comboModal.showFree"
            class="combo-free"
            style="margin-left:12px;font-size:14px;font-weight:500;color:#2e7d32;"
          >Free</span>
        </div>
        <div
          v-if="comboModal.loading && !comboModal.categories.length"
          style="padding:48px 20px;text-align:center;color:#777;"
        >
          Loading...
        </div>
        <div
          v-else
          style="overflow:auto;padding:12px 16px 20px;background:#f7f7fb;"
        >
          <div
            v-for="(category, categoryIndex) in comboModal.categories"
            :key="'combo_cat_' + categoryIndex"
            style="margin-bottom:14px;"
          >
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
              <div>
                <span style="font-weight:700;letter-spacing:0.4px;color:#6b4ea8;text-transform:uppercase;">{{ category.name }}</span>
                <span style="margin-left:8px;color:#888;font-weight:500;">{{ category.rule }}</span>
              </div>
              <span
                style="min-width:42px;padding:2px 8px;border-radius:8px;text-align:center;font-weight:600;"
                :style="category.complete ? 'background:#d8f5df;color:#1b7a32;' : 'background:#ececf2;'"
              >{{ category.selected }}/{{ category.target }}</span>
            </div>
            <div style="display:flex;flex-wrap:wrap;">
              <div
                v-for="(item, itemIndex) in category.items"
                :key="'combo_item_' + categoryIndex + '_' + itemIndex"
                :style="(item.quantity > 0 ? 'background:#e8f8ee;border-color:#b7e4c7;' : 'background:#fff;border-color:#ececf1;') + 'display:flex;justify-content:space-between;align-items:center;width:calc(33.33% - 8px);min-height:48px;margin:0 8px 8px 0;padding:8px 12px;border:1px solid #ececf1;border-radius:8px;box-sizing:border-box;'"
              >
                <span style="font-weight:600;">{{ item.name }}</span>
                <strong style="margin-left:12px;">{{ item.quantity || 0 }}</strong>
              </div>
            </div>
          </div>
          <div
            v-for="(group, groupIndex) in comboModal.extras"
            :key="'combo_extra_' + groupIndex"
            style="margin-bottom:14px;"
          >
            <div style="font-weight:700;color:#6b4ea8;margin-bottom:8px;">
              Extras · {{ group.name }}
            </div>
            <div style="display:flex;flex-wrap:wrap;">
              <div
                v-for="(item, itemIndex) in group.items"
                :key="'extra_item_' + groupIndex + '_' + itemIndex"
                :style="(item.quantity > 0 ? 'background:#e8f8ee;border-color:#b7e4c7;' : 'background:#fff;') + 'display:flex;justify-content:space-between;align-items:center;width:calc(33.33% - 8px);min-height:48px;margin:0 8px 8px 0;padding:8px 12px;border:1px solid #ececf1;border-radius:8px;box-sizing:border-box;'"
              >
                <span style="font-weight:600;">
                  {{ item.name }}
                  <small
                    v-if="item.unitPrice"
                    style="display:block;font-weight:500;color:#777;"
                  >{{ currFormat(item.unitPrice) }}</small>
                </span>
                <strong style="margin-left:12px;">{{ item.quantity || 0 }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="comboModal.showExtras"
          style="padding:14px 20px;border-top:1px solid #eee;font-size:18px;color:#666;background:#fff;"
        >
          Extras total <strong>{{ currFormat(comboModal.extrasTotal || 0) }}</strong>
        </div>
      </div>
    </div>
    <div
      v-if="extraModal.open"
      style="position:fixed;top:0;right:0;bottom:0;left:0;z-index:3000;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;padding:24px;box-sizing:border-box;"
    >
      <div style="width:92%;max-width:760px;background:#fff;border-radius:8px;box-shadow:0 12px 40px rgba(0,0,0,0.28);overflow:hidden;">
        <div style="padding:16px 20px;border-bottom:1px solid #eee;">
          <div style="font-size:22px;font-weight:600;">
            {{ extraModal.title || "Add Extra Items" }}
          </div>
          <div
            v-if="extraModal.parentItemName"
            style="margin-top:4px;font-size:16px;font-weight:600;color:#6b4ea8;"
          >
            For {{ extraModal.parentItemName }}
          </div>
        </div>
        <div style="display:flex;padding:12px 20px;font-weight:700;text-transform:uppercase;border-bottom:1px solid #eee;color:#333;">
          <span style="flex:1;">Item</span>
          <span style="width:80px;text-align:center;">Qty.</span>
          <span style="width:90px;text-align:right;">Price</span>
        </div>
        <div
          v-for="(item, itemIndex) in extraModal.items"
          :key="'extra_popup_' + itemIndex"
          style="display:flex;align-items:center;padding:12px 20px;border-bottom:1px solid #f0f0f0;"
        >
          <span style="flex:1;font-weight:600;">{{ item.name }}</span>
          <span style="width:80px;text-align:center;">{{ item.quantity || 0 }}</span>
          <span style="width:90px;text-align:right;">{{ item.price }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import { BASEURL } from "@/config/index";
import CheckoutSummary from "@/components/Pages/CheckoutSummary.vue";
import FinalTicketV2 from "@/components/Pages/FinalTicketV2.vue";
import BrandSection from "@/components/Pages/BrandSection.vue";
import CCAvenueQR from "@/components/Pages/ccAvenueQR.vue";
import ClubLoyaltySummary from "@/components/Pages/ClubLoyaltySummary.vue";
import { mapActions } from "vuex";
import CovidBlockedSeatIcon from "@/components/Partials/CovidBlockedSeatIcon.vue";
import { EventBus } from "@/main.js";
import { CLIENT_NAME } from "@/helper/Role";
import _ from "lodash";
import moment from "moment";

export default {
  name: "PosSeatLayout",
  components: {
    CheckoutSummary,
    FinalTicketV2,
    BrandSection,
    CovidBlockedSeatIcon,
    CCAvenueQR,
    ClubLoyaltySummary,
  },
  props: {},
  data() {
    return {
      movieDetails: null,
      // synopsis language selected on the POS (sent with OPEN_MOVIE_SYNOPSIS)
      synopsisContentLang: null,
      organizationDetails: null,
      finalTicketDetails: {
        type: 1,
        bookingDetails: null,
        yourTicket: null,
        bookingCode: null,
        finalAmountPaid: 0,
        fnbItems: [],
        curr_code: "",
        extraTickets: [],
      },
      sectionType: 1,
      seatTypeLocal: [],
      fnbItemsList: [],
      selectedFnbItems: [],
      alternateModal: {
        open: false,
        title: "Select Alternate Item",
        items: [],
        addedCounts: {},
      },
      comboModal: {
        open: false,
        title: "Customize combo",
        showFree: false,
        showExtras: false,
        loading: false,
        extrasTotal: 0,
        categories: [],
        extras: [],
      },
      extraModal: {
        open: false,
        title: "Add Extra Items",
        parentItemName: "",
        items: [],
      },
      currentPage: 0,
      itemsPerPage: 10,
      intervalId: null,
      fallbackImage: "@/assets/img/logos/logo-dark.png",
      numzoom: window.localStorage.getItem("zoomvalue")
        ? window.localStorage.getItem("zoomvalue")
        : 1,
      currencyData: [],
      fullscreen: false,
      posBooking: false,
      posFnb: false,
      reverse: false,
      posShowList: false,
      showCCAvenueQR: false,
      URL_BASE: BASEURL,
      selectedSeats: [],
      selectionType: "Normal", //Bulk,
      no_of_seats: 3,
      orgDetails: {},
      curr_code: "",
      FnBList: [],
      showDataArr: [],
      offerData: [],
      addonArray: [],
      ShowArrayList: [],
      deductionArray: [],
      finalAmountToPay: 0,
      RateCardAddonsChargesFinalAmount: 0,
      AdditionalChargeList: [],
      showCheckout: false,
      BookingDetails: {},
      showWanasaLogo: false,
      splitPaymentModes: [],
      change_amount: 0,
      ccAvenueQRDetails: {
        qrCode: null,
        amount: 0,
        curr_code: "",
      },
      qrisDetails: {
        qrCode: null,
        amount: 0,
        currCode: "IDR",
      },
      clubBenefits: { customer: {}, sections: [] },
    };
  },
  computed: {
    AREA_LANG_ID() {
      return this.synopsisContentLang ? this.synopsisContentLang.lang_id : null;
    },
    isSynopsisRtl() {
      const lang = this.synopsisContentLang;
      if (!lang) return false;
      const iso = String(lang.iso_2 || "").toLowerCase();
      return iso === "ar" || /arab/i.test(String(lang.lang_name || ""));
    },
    total() {
      let movieTotal = this.seats.length * 200; // assume each ticket = ₹200
      let fnbTotal = this.fnbItems.reduce((sum, i) => sum + i.price * i.qty, 0);
      return (this.movie ? movieTotal : 0) + fnbTotal;
    },
    alternateTotalAdded() {
      return Object.values(this.alternateModal.addedCounts || {}).reduce(
        (sum, count) => sum + (parseInt(count, 10) || 0),
        0
      );
    },
    totalPages() {
      return Math.ceil(this.ShowArrayList.length / this.itemsPerPage);
    },
    paginatedMovies() {
      const start = this.currentPage * this.itemsPerPage;
      return this.ShowArrayList.slice(start, start + this.itemsPerPage);
    },
    formattedDate() {
      const today = new Date();
      return today.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    currencyD() {
      return this.currencyData &&
        this.currencyData.hasOwnProperty("curr_code") &&
        this.currencyData["curr_code"]
        ? this.currencyData["curr_code"]
        : "";
    },
    QfxClient_old() {
      return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
    },
    QfxClient() {
      let hostname = window.location.hostname;
      return hostname.includes("qfxcinemas") || hostname.includes("qfx");
    },
    isEpix() {
      let hostname = window.location.hostname;
      return hostname.includes("epixcinemas");
    },
    starClient() {
      let hostname = window.location.hostname;
      return hostname.includes("starcinemas");
    },
    isSpecificClient() {
      let hostname = window.location.hostname;
      return hostname.includes("novo");
    },
    SelectedSeats() {
      return this.$store.getters.SELECTED_SEATS;
    },
    seatType() {
      return this.$store.getters.SEAT_LAYOUT_DATA;
    },
    scheduleShowId() {
      return this.$store.getters.SCHEDULE_SHOW_ID;
    },
    getScreenPosNames() {
      return this.$store.getters.getScreenPosNames;
    },
    getScheduleScreenName() {
      return this.$store.getters.getScheduleScreenName;
    },
    currency() {
      return this.$store.getters.GET_CURRENCY;
    },
    displayCurrCode() {
      return (
        this.curr_code ||
        this.currencyD ||
        this.currency ||
        ""
      );
    },
    // additonalChargeList() {
    //   return this.$store.getters.AdditionalTaxList;
    // }
    // // ...mapGetters(["AdditionalTaxList"])
  },
  watch: {
    FnBList(newVal, oldVal) {
      if (this.FnBList.length == 0) {
        this.fullscreen = false;
        this.posFnb = false;
      }
    },
    sectionType(newVal, oldVal) {
      if (this.intervalId && newVal != 2) {
        clearInterval(this.intervalId);
      } else if (newVal == 2) {
        this.intervalId = setInterval(() => {
          this.currentPage = (this.currentPage + 1) % this.totalPages;
        }, 10000); // 10 sec interval
      }

      if (newVal != 6) {
        this.finalTicketDetails = {
          type: 1,
          yourTicket: null,
          bookingDetails: null,
          bookingCode: null,
          finalAmountPaid: 0,
          fnbItems: [],
          curr_code: "",
          extraTickets: [],
        };
      }
    },
  },
  created() {
    const dualEvents = [
      ["GET_ALL_SHOWS_PAGE", this.onGetAllShowsPage],
      ["SET_SEATLAYOUT", this.onSetSeatLayout],
      ["SET_FNB_ITEMS_LIST", this.onSetFnbItemsList],
      ["SET_SELECTED_FNB_ITEMS", this.onSetSelectedFnbItems],
      ["SET_FINAL_TICKET", this.onSetFinalTicket],
      ["SYNC_FNB_SCROLL", this.onSyncFnbScroll],
      ["SET_ORG_DETAILS", this.onSetOrgDetails],
      ["SET_HOME_PAGE", this.onSetHomePage],
      ["SET_CHECKOUT_SUMMARY", this.onSetCheckoutSummary],
      ["SET_QRIS_QRCODE", this.onSetQrisQrCode],
      ["DYNAMIC_EMITTER", this.onDynamicEmitter],
      ["SET_ALTERNATE_ITEMS", this.onSetAlternateItems],
      ["SET_COMBO_CUSTOMIZE", this.onSetComboCustomize],
      ["SET_EXTRA_ITEMS", this.onSetExtraItems],
    ];
    dualEvents.forEach(([channel, handler]) => {
      this.$ipc.on(channel, handler);
    });
  },
  sockets: {
    connect: function (soc) {
      console.log("socket connected", soc);
      // window.location.reload();
    },
    GET_ALL_SHOWS_PAGE: function (data) {
      this.onGetAllShowsPage(data);
    },
    SET_SEATLAYOUT: function (data) {
      this.onSetSeatLayout(data);
    },
    SET_FNB_ITEMS_LIST: function (data) {
      this.onSetFnbItemsList(data);
    },
    SET_SELECTED_FNB_ITEMS: function (data) {
      this.onSetSelectedFnbItems(data);
    },
    SET_FINAL_TICKET: function (data) {
      this.onSetFinalTicket(data);
    },
    SYNC_FNB_SCROLL: function (percent) {
      this.onSyncFnbScroll(percent);
    },
    SET_ORG_DETAILS: function (data) {
      this.onSetOrgDetails(data);
    },
    SET_HOME_PAGE: function (data) {
      this.onSetHomePage(data);
    },
    SET_CHECKOUT_SUMMARY: function (data) {
      this.onSetCheckoutSummary(data);
    },
    SET_QRIS_QRCODE: function (data) {
      this.onSetQrisQrCode(data);
    },
    DYNAMIC_EMITTER: function (data) {
      this.onDynamicEmitter(data);
    },
    SET_ALTERNATE_ITEMS: function (data) {
      this.onSetAlternateItems(data);
    },
    SET_COMBO_CUSTOMIZE: function (data) {
      this.onSetComboCustomize(data);
    },
    SET_EXTRA_ITEMS: function (data) {
      this.onSetExtraItems(data);
    },
    zoomvalue: function (data) {
      this.numzoom = data;
      window.localStorage.setItem("zoomvalue", data);
    },
    selectSeatLayout: function (data) {},
    // setSeatLayout: function (data) {
    //   this.fullscreen = true;
    // },
    // setDemo: function (data) {
    //   console.log("data :", data);
    //   this.fullscreen = false;
    // },
    setOrgDetails: function (data) {
      console.log("data :", data);
      this.orgDetails = data;
    },
    // setPosSeatLayout: function (flag, currency_code) {
    //   console.log("flag>>>>>", flag, currency_code);
    //   this.fullscreen = flag[0];
    //   this.posBooking = flag[0];
    //   this.curr_code = this.fullscreen[1];
    // },

    // setHomePage: function () {
    //   console.log("dsfsdfsd");
    //   this.fullscreen = false;
    //   this.posBooking = false;
    //   this.showCheckout = false;
    //   this.showCCAvenueQR = false;
    //   this.posFnb = false;
    //   this.FnBList = [];
    //   this.addonArray = [];
    //   this.offerData = [];
    //   this.showDataArr = [];
    //   this.AdditionalChargeList = [];
    // },
    setDynamicDetails: function (data) {
      const { type = "", payload = null } = data;
      if (type == "setCCAvenueQR" && payload) {
        Object.keys(this.ccAvenueQRDetails).map((key) => {
          this.ccAvenueQRDetails[key] =
            payload && payload[key]
              ? payload[key]
              : this.ccAvenueQRDetails[key];
        });
        this.fullscreen = false;
        this.posBooking = false;
        this.showCheckout = false;
        this.showCCAvenueQR = true;
        this.sectionType = 7;
        this.posFnb = false;
        this.FnBList = [];
      }
    },
    // setNumberofSeats: function (data) {
    //   console.log("data>>>>>>>><<<<<<<<<<< :", data);
    //   this.$store.dispatch("SelectNumberOfSeats", data.number);
    // },
    // seatSelectionFromBrij: async function (data) {
    //   console.log("data :::::", data);
    //   // await this.$store.dispatch("SET_SCHEDULE_SHOW_ID", data.scheduleShowId);
    //   // await this.$store.dispatch("MAKE_SEAT_EMPTY");
    //   // let payload = {
    //   //   seat: data.seat,
    //   //   rowIndex: data.rowIndex,
    //   //   seatIndex: data.seatIndex,
    //   //   originalIndex: data.originalIndex,
    //   //   backward: data.backward,
    //   //   e: data.e,
    //   //   type: data.type,
    //   // };
    //   await this.$store.dispatch("seatHandler", data);

    // },
  },
  beforeMount() {
    this._GetOrganization();
    this._GetGlobalOptions();
    this.showWanasaLogo = window.location.origin.includes("wanasa");
    let orgData = this.secureStore.get("ORGData");
    console.log(orgData, "orgData");
    if (orgData && orgData.length > 0) {
      this.orgDetails = orgData[0];
    }
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  mounted() {
    console.log("object :");
    this.getCurrencyCode();
    // this.getSeatLayout();
    let self = this;

    if (true) {
      EventBus.$on("ScrollIntoSelectedSeat", (data) => {
        console.log(data, "Comming Data ScrollinG");

        if (data) {
          setTimeout(() => {
            // const el = document.querySelector(`#${data}`);
            // console.log(el, "elllllll");
            // if (el) {
            //   el.scrollIntoView();
            // }
            const el = document.getElementById(String(data));
            console.log(el, "elllllll");
            if (el) {
              el.scrollIntoView({
                behavior: "auto",
                block: "center",
                inline: "center",
              });
            }

            // self.$refs["7179"].$el.scrollIntoView({ behavior: "smooth" });
          }, 1000);

          // self.$refs["7179"].$el.scrollIntoView({ behavior: "smooth" });
        }
      });
    }
    // console.log(this.clubBenefits,"this.clubBenefitsthis.clubBenefits")
    // this.$store.dispatch("NO_OF_SEATS", no_of_seats);
  },

  methods: {
    moment,
    getSafe(
      fn,
      fallbackValue = undefined,
      useFallbackForFalsyGetSafeValue = true
    ) {
      try {
        let result = fn();

        if (!result && useFallbackForFalsyGetSafeValue) {
          result = fallbackValue;
        }

        return result;
      } catch (e) {
        return fallbackValue;
      }
    },
    getSeatIconURL(singleSeat) {
      let iconPath = ``;
      if (singleSeat.selectStatus) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
      } else if (
        singleSeat.seat_reserve_type_id == 12 ||
        singleSeat.seat_reserve_type_id == 8
      ) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
      } else {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
      }
      // this.$forceUpdate();
      return iconPath;
    },
    toCheckAlphabets(str) {
      // let { sl_seat_name = "" } = str[0];
      let regex = /[a-zA-Z]/g;
      let regexstrnNum = /^[A-Za-z0-9]*$/;
      // const text = '12abc34';
      // console.log(str[0],"strrrrr")
      if (str && str.match(regex)) {
        return true;
      }
      return false;
    },
    checkSeatPriortyColor(seat) {
      if (
        this.showChannelWiseBookings == "Y" &&
        seat.hasOwnProperty("booking_color") &&
        seat["booking_color"]
      ) {
        return seat["booking_color"];
      } else if (seat.seat_reserve_type_id == 8 && !seat.is_booking_done) {
        return "#d3d3d3";
      } else if (seat.seat_reserve_type_id == 8) {
        return this.QfxClient ? "#dc3545" : "#d3d3d3";
      } else {
        return "";
      }
    },
    getSelectedCount(item_id) {
      const QTY =
        this.selectedFnbItems
          .filter((x) => x.item_id == item_id)
          .reduce((acc, { quantity }) => acc + parseFloat(quantity), 0) || 0;
      return QTY;
    },
    timeSinceShowElapsed() {},
    getSortArrayHere: function (data) {
      return _.sortBy(data, ["ss_actual_start_date_time"]);
    },
    handleImageError(event) {
      // Update the src attribute to use the fallback image
      event.target.src = this.fallbackImage;
    },
    // POS OFFERS SAIF START
    ...mapActions(["fetchOffersList", "onSetSelectedOfferId"]),
    // POS OFFERS SAIF END
    isWheelChairOnlyRow(SeatTypeArray = []) {
      let statusCount = 0;

      SeatTypeArray.forEach((row) => {
        row.forEach((x) => {
          if (x.seat_reserve_type_id != 2 && x.seat_reserve_type_id != 3) {
            statusCount++;
          }
        });
      });

      if (statusCount > 0) {
        return false;
      } else {
        return true;
      }
    },
    onGetAllShowsPage(data) {
      this.sectionType = 2;
      console.log("data", data);
      this.ShowArrayList = data;
    },
    onSetSeatLayout(data) {
      this.sectionType = 3;
      this.seatTypeLocal = data;
    },
    onSetFnbItemsList(data) {
      this.sectionType = 4;
      this.fnbItemsList = Array.isArray(data) ? data : [];
      if (this.fnbItemsList.length) {
        this.fnbItemsList.forEach((x) => {
          if (x) x["quantity"] = 0;
        });
      }
    },
    onSetSelectedFnbItems(data) {
      this.selectedFnbItems = data && data.length ? data : [];
    },
    onSetFinalTicket(data) {
      console.log(" SET_FINAL_TICKET data", data);
      this.finalTicketDetails = {
        type: (data && data.type) || 1,
        bookingDetails: (data && data.bookingDetails) || null,
        yourTicket: (data && data.yourTicket) || null,
        bookingCode: (data && data.bookingCode) || null,
        finalAmountPaid: (data && data.finalAmountPaid) || 0,
        fnbItems: (data && data.fnbItems) || [],
        curr_code: (data && data.curr_code) || "",
        extraTickets: (data && data.extraTickets) || [],
      };
      this.sectionType = 6;
    },
    onSyncFnbScroll(percent) {
      console.log("SYNC_FNB_SCROLL data", percent, this.$refs.fnbSection);
      const el = this.$refs.fnbSection;
      if (!el) return;
      let maxScroll = el.scrollHeight - el.clientHeight;
      let scrollTop = maxScroll * percent;
      el.scrollTop = scrollTop;
    },
    onSetOrgDetails(data) {
      console.log("SET_ORG_DETAILS data", data);
      this.organizationDetails = data;
    },
    onSetHomePage(data) {
      console.log("SET_HOME_PAGE data", data);
      this.sectionType = 1;
      this.alternateModal = {
        open: false,
        title: "Select Alternate Item",
        items: [],
        addedCounts: {},
      };
      this.comboModal = {
        open: false,
        title: "Customize combo",
        showFree: false,
        showExtras: false,
        loading: false,
        extrasTotal: 0,
        categories: [],
        extras: [],
      };
      this.extraModal = {
        open: false,
        title: "Add Extra Items",
        parentItemName: "",
        items: [],
      };
    },
    onSetCheckoutSummary(data) {
      if (!data) return;
      this.sectionType = 5;
      this.curr_code = data.hasOwnProperty("curr_code")
        ? data["curr_code"]
        : [];
      this.finalAmountToPay = data.hasOwnProperty("finalAmountToPay")
        ? data["finalAmountToPay"]
        : 0;
      this.splitPaymentModes = data.hasOwnProperty("splitPaymentModes")
        ? data["splitPaymentModes"].filter((x) => x.amount > 0)
        : [];
      this.change_amount = data.hasOwnProperty("change_amount")
        ? parseFloat(data["change_amount"] || 0).toFixed(2)
        : 0;
      this.FnBList = data.hasOwnProperty("fnbItems") ? data["fnbItems"] : [];
      this.deductionArray = data.hasOwnProperty("deductionArray")
        ? data["deductionArray"]
        : [];
      this.AdditionalChargeList = data.hasOwnProperty("charges")
        ? data["charges"]
        : [];
      this.showDataArr = data.hasOwnProperty("showDataArr")
        ? data["showDataArr"]
        : [];
      this.offerData = data.hasOwnProperty("offerData")
        ? data["offerData"]
        : [];
      this.RateCardAddonsChargesFinalAmount = data.hasOwnProperty(
        "RateCardAddonsChargesFinalAmount"
      )
        ? data["RateCardAddonsChargesFinalAmount"]
        : 0;
      this.addonArray = data.hasOwnProperty("addonArray")
        ? data["addonArray"]
        : [];
    },
    onSetQrisQrCode(data) {
      this.sectionType = 8;
      this.qrisDetails = data;
    },
    onSetAlternateItems(data) {
      this.alternateModal = {
        open: !!(data && data.open),
        title: (data && data.title) || "Select Alternate Item",
        items: (data && data.items) || [],
        addedCounts: (data && data.addedCounts) || {},
      };
    },
    onSetExtraItems(data) {
      this.extraModal = {
        open: !!(data && data.open),
        title: (data && data.title) || "Add Extra Items",
        parentItemName: (data && data.parentItemName) || "",
        items: (data && data.items) || [],
      };
    },
    onSetComboCustomize(data) {
      this.comboModal = {
        open: !!(data && data.open),
        title: (data && data.title) || "Customize combo",
        showFree: !!(data && data.showFree),
        showExtras: !!(data && data.showExtras),
        loading: !!(data && data.loading),
        extrasTotal: data && data.extrasTotal ? data.extrasTotal : 0,
        categories: (data && data.categories) || [],
        extras: (data && data.extras) || [],
      };
    },
    alternateAddedCount(itemId) {
      const counts = this.alternateModal.addedCounts || {};
      return counts[itemId] || counts[String(itemId)] || 0;
    },
    onDynamicEmitter(data) {
      if (!data) return;
      if (data["emit_type"] == "SET_CUSTOMER_CLUB_LOYALTY") {
        this.sectionType = 9;
        this.clubBenefits = data;
      }
      if (data["emit_type"] == "OPEN_MOVIE_SYNOPSIS") {
        this.movieDetails = data["data"] || null;
        this.synopsisContentLang = data["content_lang"] || null;
        if (data["modal"]) {
          this.$bvModal.show("listed-movie-synopsis");
        } else {
          this.$bvModal.hide("listed-movie-synopsis");
        }
      }
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            if (this.currencyData.curr_code) {
              this.$store.dispatch(
                "SAVE_CURRENCY",
                this.currencyData.curr_code
              );
              if (!this.curr_code) {
                this.curr_code = this.currencyData.curr_code;
              }
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
  },
};
</script>

<style>
.flexSeats {
  border: 2px solid black;
  border-radius: 10px;
  min-width: 40px !important;
  height: 40px !important;
  justify-content: center;
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 14px;
  text-transform: uppercase;
}

.qrisQrcode {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
}

.grey {
  background-color: lightgray;
}

.hideScreen {
  height: 0;
  margin-bottom: 0 !important;
  overflow: hidden;
}

.final-ticket-screen {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}

.normal-seat {
  display: none !important;
}

.pos-seatlayout table td {
  min-width: 50px;
  max-width: 65px;
  min-height: 50px;
  padding-bottom: 2px;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  transition: transform 0.2s, -webkit-transform 0.2s;
}

.pos-seatlayout table td.pos-seatLayoutTitle {
  min-width: 50px;
  max-width: 65px;
  min-height: 50px;
  padding-bottom: 2px;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
}

.pos-seatlayout-rotate {
  transform: scale(1, -1);
}

.pos-seatlayout-rotate-text {
  transform: scale(1, -1);
}

.marketing-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 30px;
}

.seatTypetext {
  width: 100%;
  font-weight: bold;
  font-size: 16px;
  padding: 8px 0px 8px 0px;
  text-align: center;
  letter-spacing: 1px;
  text-decoration: underline;
  /* border-bottom: 1px solid #000; */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style scoped>
.dual-display {
  /* background: #111; */
  /* color: #fff; */
  background: #e8e8e8;
  color: black;
  padding: 10px;
  font-family: Arial, sans-serif;
  height: 100vh;
  overflow-y: auto;
}

.header {
  text-align: center;
  padding: 5px 0;
  font-size: 14px;
  border-bottom: 1px solid #444;
  margin-bottom: 10px;
}

.movies {
  /* display: flex;
  flex-direction: column;
  gap: 10px; */

  /* display: flex;
  flex-wrap: wrap;
  gap: 10px; */
}

.flex-container {
  /* display: flex;
  flex-wrap: wrap;
  gap: 10px; */
}

.movies {
  display: flex;
  flex-wrap: wrap;
  /* allows wrapping */
  margin: -5px;
  /* compensate for child margins */
}

.movies > * {
  margin: 5px;
  /* 5px + 5px = 10px between items */
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  /* allows wrapping */
  margin: -5px;
  /* compensate */
}

.flex-container > * {
  margin: 5px;
}

/* On small screens, make it 1 per row */
@media (max-width: 768px) {
  .movie-card {
    flex: 1 1 100%;
  }
}

.movie-card {
  flex: 1 1 calc(50% - 10px);
  /* 2 per row by default */
  box-sizing: border-box;
  display: flex;
  /* background: #1a1a1a; */
  background: white;
  border-radius: 8px;
  padding: 8px;
  align-items: center;
}

.poster img {
  width: 60px;
  height: 90px;
  border-radius: 5px;
  object-fit: cover;
}

.info {
  margin-left: 10px;
  flex: 1;
}

.title {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 2px;
}

.meta {
  font-size: 12px;
  color: #aaa;
  margin-bottom: 5px;
}

.showtimes {
  display: flex;
  flex-wrap: wrap;
  /* gap: 5px; */
}

.showtime {
  /* background: #2ecc71; */
  border: 1px solid #337539;
  color: #337539;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  margin: 5px;
}
</style>

<style scoped>
.display-wrapper {
  padding: 10px;
  font-family: sans-serif;
  text-align: center;
}

.title {
  /* margin-bottom: 12px;
  font-size: 18px;
  font-weight: bold; */
}

/* Responsive grid */
.fnb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.fnbSection {
  max-height: calc(100vh - 45px);
  height: calc(100vh - 45px);
  overflow-y: auto;
}

.fnb-card {
  position: relative;
  /* Needed for badge */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 6px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fnb-card img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 6px;
}

.name {
  font-size: 14px;
  font-weight: 600;
}

.price {
  font-size: 12px;
  color: #666;
}

.alternate-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.alternate-dialog {
  width: min(920px, 96vw);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
  overflow: hidden;
}

.alternate-dialog-header {
  padding: 14px 20px;
  font-size: 22px;
  font-weight: 600;
  border-bottom: 1px solid #eaeaed;
}

.alternate-items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px;
  background: #f6f6f6;
  min-height: 180px;
}

.alternate-card {
  position: relative;
  width: 220px;
  min-height: 140px;
  background: #ffe7a3;
  border: 1px solid #e6d08a;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  text-align: center;
}

.alternate-card img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 8px;
  background: #fff;
}

.alternate-empty {
  padding: 48px 20px;
  text-align: center;
  color: #777;
}

.alternate-dialog-footer {
  padding: 14px 20px;
  border-top: 1px solid #eee;
  font-size: 18px;
  color: #666;
}

.combo-dialog {
  width: min(1100px, 96vw);
  max-height: 90vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.combo-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  font-size: 22px;
  font-weight: 600;
  border-bottom: 1px solid #eaeaed;
}

.combo-free {
  font-size: 14px;
  font-weight: 500;
  color: #2e7d32;
}

.combo-sections {
  overflow: auto;
  padding: 12px 16px 20px;
  background: #f7f7fb;
}

.combo-section {
  margin-bottom: 14px;
}

.combo-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.combo-section-name {
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #6b4ea8;
  text-transform: uppercase;
}

.combo-section-rule {
  margin-left: 8px;
  color: #888;
  font-weight: 500;
  text-transform: none;
}

.combo-count {
  min-width: 42px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #ececf2;
  text-align: center;
  font-weight: 600;
}

.combo-count.complete {
  background: #d8f5df;
  color: #1b7a32;
}

.combo-items {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.combo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #ececf1;
  border-radius: 8px;
}

.combo-item.selected {
  background: #e8f8ee;
  border-color: #b7e4c7;
}

.combo-item-name {
  font-weight: 600;
}

.combo-item-name small {
  display: block;
  font-weight: 500;
  color: #777;
}

.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #76e27f;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Smaller screens */
@media (max-width: 500px) {
  .fnb-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
  }

  .fnb-card img {
    width: 45px;
    height: 45px;
  }

  .name {
    font-size: 12px;
  }

  .price {
    font-size: 10px;
  }
}
</style>
<style scoped>
.checkout-summary {
  padding: 12px;
  font-family: sans-serif;
}

.checkout-summary .title {
  text-align: center;
  margin-bottom: 15px;
}

.checkout-summary .movie-section,
.checkout-summary .food-section {
  margin-bottom: 15px;
}

.checkout-summary .movie-details {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
}

.checkout-summary .poster {
  width: 70px;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
}

.checkout-summary .info p {
  margin: 2px 0;
  font-size: 14px;
}

.checkout-summary .seats {
  margin-top: 6px;
  font-size: 14px;
}

.checkout-summary .fnb-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.checkout-summary .fnb-item {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
}

.checkout-summary .fnb-item img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.checkout-summary .name {
  font-weight: 600;
  font-size: 14px;
}

.checkout-summary .qty,
.checkout-summary .price {
  font-size: 12px;
  color: #555;
}

.checkout-summary .total {
  text-align: right;
  font-size: 16px;
  margin-top: 12px;
  font-weight: bold;
  border-top: 1px solid #ccc;
  padding-top: 8px;
}

/* Responsive small display */
@media (max-width: 500px) {
  .checkout-summary .poster {
    width: 50px;
    height: 70px;
  }

  .checkout-summary .info p {
    font-size: 12px;
  }

  .checkout-summary .name {
    font-size: 12px;
  }
}


/* ===========================================
   Client Specific Layout
   =========================================== */

.dual-display-client .movies {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 8px;
  width: 100%;
  align-items: stretch;
}

.dual-display-client .movie-card {
  display: flex;
  align-items: flex-start;
  height: 100%;
  min-width: 0;
  padding: 10px;
  border-radius: 8px;
  box-sizing: border-box;
}

.dual-display-client .poster {
  flex: 0 0 140px;
  width: 140px;
  height: 95px;
  margin-right: 12px;
}

.dual-display-client .poster img {
  width: 100px;
  height: 150px;
  border-radius: 5px;
  object-fit: cover;
}

.dual-display-client .info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.dual-display-client .title {
  font-size: 17px;
  line-height: 1.3;
  margin: 0 0 6px;
  word-break: break-word;
}

.dual-display-client .meta {
  font-size: 13px;
  line-height: 1.4;
  margin: 0 0 8px;
}

.dual-display-client .showtimes {
  margin-top: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.dual-display-client .showtime {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

/* ===========================================
   Tablet - Always 2 Cards
   =========================================== */

@media (max-width: 900px) {
  .dual-display-client .movies {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dual-display-client .poster {
    flex: 0 0 120px;
    width: 120px;
    height: 85px;
  }

  .dual-display-client .title {
    font-size: 16px;
  }

  .dual-display-client .meta {
    font-size: 12px;
  }

  .dual-display-client .showtime {
    font-size: 11px;
    padding: 3px 6px;
  }
}

/* ===========================================
   Small Mobile - Single Card
   =========================================== */

@media (max-width: 600px) {
  .dual-display-client .movies {
    grid-template-columns: 1fr;
  }

  .dual-display-client .movie-card {
    padding: 8px;
  }

  .dual-display-client .poster {
    flex: 0 0 110px;
    width: 110px;
    height: 80px;
    margin-right: 10px;
  }

  .dual-display-client .title {
    font-size: 15px;
  }

  .dual-display-client .meta {
    font-size: 11px;
  }

  .dual-display-client .showtime {
    font-size: 10px;
    padding: 3px 6px;
  }
}
</style>
